import {Overlay, OverlayConfig, OverlayRef} from '@angular/cdk/overlay';
import {AfterViewInit, Directive, OnDestroy, ViewChild} from '@angular/core';
import {TemplatePortalDirective} from '../../directives/template-portal.directive';

/**
 * This abstract component is a helper component helping you to move your components html to the cdk overlay html tag,
 * so that it won't be included at the current dom position. The bindings still work like usual.
 *
 * For using it your components html must start with a <ng-template> tag including the {@link TemplatePortalDirective}.
 * For example:
 * <ng-template appTemplatePortal><span>I'll be moved</span></ng-template>
 */
@Directive()
export abstract class AbstractPortalToOverlayComponent implements OnDestroy, AfterViewInit {
    @ViewChild(TemplatePortalDirective, {static: true})
    private portal: TemplatePortalDirective;

    private overlayRef: OverlayRef;

    protected constructor(private overlay: Overlay) {
    }

    public ngAfterViewInit() {
        console.log('attaches portal to overlay component: ', this.constructor.name);

        this.overlayRef = this.overlay.create(this.createOverlayConfig());
        this.overlayRef.attach(this.portal);
    }

    public ngOnDestroy() {
        console.log('dispose portal to overlay component: ', this.constructor.name);

        this.overlayRef.dispose();
    }

    /**
     * Override this method to create your own overlay config.
     * @returns {OverlayConfig} Configuration for your overlay element.
     */
    // noinspection JSMethodCanBeStatic
    protected createOverlayConfig(): OverlayConfig {
        return new OverlayConfig();
    }
}
